import BoldSmallText from '@/components/BoldSmallText';
import InformationBanner from '@/components/InformationBanner';
import { PlanMessage } from '@/components/PlanMessage';
import { PricingPlan } from '@/constants/enum';
import { handleVisibleBanner, isOpenInstructionPreSelectBannerSelector } from '@/redux/slice/banner.slice';
import { handleSaveWidgetSettings, widgetAppearanceDisableSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Checkbox, InlineStack } from '@shopify/polaris';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const WidgetPreSelected = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();
  const isOpenInstructionPreSelectBanner = useSelector(isOpenInstructionPreSelectBannerSelector);
  const [isOpenInfor, setIsOpenInfor] = useState<boolean>(isOpenInstructionPreSelectBanner);
  const widgetAppearanceDisable = useSelector(widgetAppearanceDisableSelector);

  return (
    <BlockStack gap={'300'}>
      <InformationBanner
        title=""
        isVisible={isOpenInfor}
        onDismiss={() => {
          setIsOpenInfor(false);
          dispatch(handleVisibleBanner({ key: 'isOpenInstructionPreSelectBanner', value: false }));
        }}
      >
        Refreshing the page or switching back to a previous pickup location will clear the pre-selection, requiring buyers to
        manually choose their date and time.
      </InformationBanner>
      <InlineStack align="space-between">
        <BoldSmallText>{t('widgetDesign.general.preSelected.title')}</BoldSmallText>
        {widgetAppearanceDisable.isDisablePreSelect && <PlanMessage plan={PricingPlan.Smart} />}
      </InlineStack>
      <Checkbox
        label={t('widgetDesign.general.preSelected.checkboxTitle')}
        helpText={t('widgetDesign.general.preSelected.checkboxHelpText')}
        checked={widgetSettings.preSelectedValue?.firstAvailableSlot || false}
        onChange={() =>
          dispatch(
            handleSaveWidgetSettings({
              preSelectedValue: {
                firstAvailableSlot: !widgetSettings.preSelectedValue?.firstAvailableSlot,
              },
            }),
          )
        }
        disabled={widgetAppearanceDisable.isDisablePreSelect}
      />
    </BlockStack>
  );
};
